var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "005---Sync-ANF---Select-Target-Volume",
    transform: "translate(-665.000000, -395.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table",
    transform: "translate(318.000000, 343.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "table-header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter_ic",
    transform: "translate(347.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_filter_341297_000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.90198864,9.73721591 L9.09801136,9.73721591 L9.09801136,8.13920455 L5.90198864,8.13920455 L5.90198864,9.73721591 Z M0.0426136364,0.149147727 L0.0426136364,1.74715909 L14.9573864,1.74715909 L14.9573864,0.149147727 L0.0426136364,0.149147727 Z M2.70596591,5.76818182 L12.2940341,5.76818182 L12.2940341,4.11823295 L2.70596591,4.11823295 L2.70596591,5.76818182 Z",
    id: "Shape",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.ec1dbd84e131fec80c545f1b55929376.svg";
export { ForwardRef as ReactComponent };